import { TableHead } from '@mui/material';
import { BaseTableHeadProps } from './BaseTableHead.types';

/**
 * The base MUI TableHead used as an entry point and as separation for mocking.
 *
 * @param classes - {@link BaseTableHeadProps.classes classes} description.
 * @param children - {@link BaseTableHeadProps.children children} description.
 */
export const BaseTableHead = ({
    classes,
    children,
}: BaseTableHeadProps) => {
    return (
        <TableHead
            classes={{
                ...classes,
            }}
        >
            {children}
        </TableHead>
    );
};